import orders from './dashboard/orders'
import cards from './dashboard/cards'
export default {
    modules: {
        orders, 
        cards
    }
}